import styled from '@emotion/styled';

import { BREAKPOINTS, MAX_CONTENT_WIDTH } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

/**
 * @deprecated - use Container form Chakra UI
 */

const ContainerElement = styled('div')<IThemeProps>`
  margin: 0 20px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    width: 100%;
    max-width: ${MAX_CONTENT_WIDTH}px;
    margin: 0 auto;
    padding: 0 10px;
  }
`;

export const Container = ({ children, ...restProps }) => {
  return <ContainerElement {...restProps}>{children}</ContainerElement>;
};

export const ScrollableSpacerItem = styled.div<IThemeProps & { spaceBetween: number }>`
  &:not(:last-of-type) {
    margin-right: ${({ spaceBetween }) => spaceBetween}px;
  }
`;
